import axios from '@/libs/api.request'

// 管理员列表
export const apiAdminUserList = data => {
  return axios.request({
    url: '/admin/admin-user',
    method: 'get',
    data,
  })
}
// 管理员详情
export const apiAdminUserDetail = (id, data) => {
  return axios.request({
    url: `/admin/admin-user/${id}`,
    method: 'get',
    data,
  })
}
// 管理员新增
export const apiAdminUserAdd = data => {
  return axios.request({
    url: '/admin/admin-user',
    method: 'post',
    data,
  })
}
// 管理员删除
export const apiAdminUserDelete = (id, data) => {
  return axios.request({
    url: `/admin/admin-user/${id}`,
    method: 'delete',
    data,
  })
}
// 管理员编辑
export const apiAdminUserEdit = (id, data) => {
  return axios.request({
    url: `/admin/admin-user/${id}`,
    method: 'put',
    data,
  })
}

// 管理员启用和冻结
export const apiAdminUserUpdateStatus = (id, data) => {
  return axios.request({
    url: `/admin/admin-user/update-status/${id}`,
    method: 'get',
    data,
  })
}
// 获取权限
export const apiGetPermission = data => {
  return axios.request({
    url: `/admin/permission`,
    method: 'get',
    data,
  })
}
